import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createStore } from 'vuex';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import echarts from './plugins/echarts';

// Create Vuex store
const store = createStore({
  state: {
    // Initial state
  },
  mutations: {
    // Mutations
  },
  actions: {
    // Actions
  }
});

const app = createApp(App);
app.use(router);
app.use(store);
app.use(ElementPlus);
app.use(echarts);
app.mount('#app');
